function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5 0v1H1.045v13H14v-4h1v5H0V0h5zm10 0v7h-1V1.792l-8.424 8.583-.707-.707L13.376 1H8.03V0H15z",
  fill: "#1F140F",
  fillRule: "evenodd"
});

var SvgLinkexternal = function SvgLinkexternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE1cHgiIGhlaWdodD0iMTVweCIgdmlld0JveD0iMCAwIDE1IDE1IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNTkuMSAoODYxNDQpIC0gaHR0cHM6Ly9za2V0Y2guY29tIC0tPg0KICAgIDx0aXRsZT5saW5rZXh0ZXJuYWw8L3RpdGxlPg0KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPg0KICAgIDxnIGlkPSJsaW5rZXh0ZXJuYWwiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8cGF0aCBkPSJNNSwwIEw1LDEgTDEuMDQ0Nzk5OCwxIEwxLjA0NDc5OTgsMTQgTDE0LDE0IEwxNCwxMCBMMTUsMTAgTDE1LDE1IEwwLDE1IEwwLDAgTDUsMCBaIE0xNSwtMi43OTMzMjExM2UtMTMgTDE1LDcgTDE0LDcgTDEzLjk5OTg0ODksMS43OTE1MDY0OCBMNS41NzY0NjQyMSwxMC4zNzUxODE3IEw0Ljg2OTM1NzQzLDkuNjY4MDc0OTUgTDEzLjM3NjE4MDcsMC45OTk1NDY4OSBMOC4wMzAxNTEzNywxIEw4LjAzMDE1MTM3LC0yLjgxNTUyNTU5ZS0xMyBMMTUsLTIuNzkzMzIxMTNlLTEzIFoiIGlkPSJDb21iaW5lZC1TaGFwZSIgZmlsbD0iIzFGMTQwRiI+PC9wYXRoPg0KICAgIDwvZz4NCjwvc3ZnPg==";
export { SvgLinkexternal as ReactComponent };